var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDefaultGrayFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H7ZM10.4443 13.5556L8.05545 11.1667C7.85174 10.963 7.59248 10.8611 7.27767 10.8611C6.96285 10.8611 6.7036 10.963 6.49989 11.1667C6.29619 11.3704 6.19434 11.6296 6.19434 11.9444C6.19434 12.2593 6.29619 12.5185 6.49989 12.7222L9.66656 15.8889C9.88878 16.1111 10.148 16.2222 10.4443 16.2222C10.7406 16.2222 10.9999 16.1111 11.2221 15.8889L17.4999 9.61111C17.7036 9.40741 17.8054 9.14815 17.8054 8.83333C17.8054 8.51852 17.7036 8.25926 17.4999 8.05556C17.2962 7.85185 17.0369 7.75 16.7221 7.75C16.4073 7.75 16.148 7.85185 15.9443 8.05556L10.4443 13.5556Z",
    fill: "#D3DAE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDefaultGrayFill);
export default __webpack_public_path__ + "static/media/check_default_gray_fill.4bfcb30b68bc75162cc85d0d6f4fd8d9.svg";
export { ForwardRef as ReactComponent };